(function () {
  function refreshHeaderCartIcon() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;

    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('[id^="shopify-section-"]');
        if (sectionEl) link.innerHTML = sectionEl.innerHTML;
      })
      .catch(function () {});
  }

  function getComponents(root) {
    var el = root.querySelector('[data-product-bundle-components]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Reads the live selected variant from the main variant picker above, so
  // the bundle reflects whatever the customer currently has selected —
  // falling back to the variant this module was rendered with.
  function currentBaseVariantId(root) {
    var infoContainer = root.closest('.product__info-container') || document;
    var variantSelects = infoContainer.querySelector('variant-selects');
    var script = variantSelects ? variantSelects.querySelector('[data-selected-variant]') : null;
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {}
    }
    return root.dataset.baseVariantId;
  }

  function syncSelfThumb(root) {
    var img = root.querySelector('[data-product-bundle-self-thumb-img]');
    var components = getComponents(root);
    if (!img || !components) return;
    var info = components.items[0].variants[currentBaseVariantId(root)];
    if (info && info.image) img.src = info.image;
  }

  function syncPartnerThumb(root, index, select) {
    var img = root.querySelector('[data-product-bundle-partner-thumb-img="' + index + '"]');
    var components = getComponents(root);
    if (!img || !components || !select) return;
    var item = components.items[index];
    var info = item && item.variants[select.value];
    if (info && info.image) img.src = info.image;
  }

  function initBundle(root) {
    // Always re-sync the self thumbnail, even on nodes we've already
    // initialized — the main variant picker can re-render around this
    // module without necessarily replacing it, so this needs to run every time.
    syncSelfThumb(root);

    if (root.dataset.productBundleReady === 'true') return;
    root.dataset.productBundleReady = 'true';

    var bundleVariantId = root.dataset.bundleVariantId;
    var ctaButton = root.querySelector('[data-product-bundle-submit]');
    var partnerSelects = root.querySelectorAll('[data-product-bundle-partner-select]');
    var infoContainer = root.closest('.product__info-container') || document;
    var quantityInput = infoContainer.querySelector('.quantity__input, input[name="quantity"]');

    function selectedQuantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function selectedPurchaseOption() {
      var checked = root.querySelector('[data-product-bundle-radio]:checked');
      return checked ? checked.value : 'bundle';
    }

    partnerSelects.forEach(function (select) {
      var index = parseInt(select.dataset.productBundlePartnerSelect, 10);
      select.addEventListener('change', function () {
        syncPartnerThumb(root, index, select);
      });
      syncPartnerThumb(root, index, select);
    });

    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        if (ctaButton.getAttribute('aria-disabled') === 'true') return;

        var components = getComponents(root);
        var option = selectedPurchaseOption();
        var baseVariantIdNow = currentBaseVariantId(root);
        var bundleItem = { id: option === 'single' ? baseVariantIdNow : bundleVariantId, quantity: selectedQuantity() };

        if (option === 'bundle' && components) {
          var properties = { _bundle_items_count: String(components.items.length) };
          var labelsByHandle = {};

          components.items.forEach(function (item, index) {
            var variantInfo;
            if (index === 0) {
              variantInfo = item.variants[baseVariantIdNow] || {};
            } else {
              var select = root.querySelector('[data-product-bundle-partner-select="' + index + '"]');
              var variantId = select ? select.value : item.defaultVariantId;
              variantInfo = item.variants[variantId] || {};
            }
            var label = variantInfo.title ? item.title + ' - ' + variantInfo.title : item.title;

            properties['_bi_' + index + '_title'] = item.title;
            properties['_bi_' + index + '_variant'] = variantInfo.title || '';
            properties['_bi_' + index + '_image'] = variantInfo.image || '';
            properties[item.title] = label;
            labelsByHandle[item.handle] = label;
          });

          var orderedHandles = components.order || components.items.map(function (item) {
            return item.handle;
          });
          var selectionLabels = orderedHandles
            .map(function (handle) {
              return labelsByHandle[handle];
            })
            .filter(Boolean);

          properties['_bundle_selection'] = selectionLabels.join(' <> ');
          bundleItem.properties = properties;
        }

        var items = [bundleItem];

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var bodyData = { items: items };
        if (cart) {
          bodyData.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          bodyData.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }

        ctaButton.setAttribute('aria-disabled', 'true');
        ctaButton.classList.add('loading');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(bodyData),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function (response) {
            if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE(function () {
                if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
                refreshHeaderCartIcon();
              });
            } else if (cart) {
              cart.classList.remove('is-empty');
              cart.renderContents(response);
              refreshHeaderCartIcon();
            } else {
              refreshHeaderCartIcon();
            }
          })
          .catch(function () {})
          .finally(function () {
            ctaButton.removeAttribute('aria-disabled');
            ctaButton.classList.remove('loading');
          });
      });
    }
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-product-bundle]').forEach(initBundle);
  }

  setupAll();

  // The main variant picker re-renders the product info column on change
  // (Dawn's standard AJAX section refresh), which can replace this module's
  // markup wholesale — watch for that and re-run setup so listeners stay
  // attached and the self thumbnail keeps tracking the selected variant.
  var infoContainers = document.querySelectorAll('.product__info-container');
  if (window.MutationObserver && infoContainers.length) {
    infoContainers.forEach(function (container) {
      new MutationObserver(function () {
        setupAll(container);
      }).observe(container, { childList: true, subtree: true });
    });
  }
})();
